import { randNumber, randCatchPhrase } from '@ngneat/falso';

import { PinnedReport } from '../user/pinned-report';

export class MockPinnedReport extends PinnedReport {
   constructor() {
      super();

      this.id = randNumber({ max: 100 });
      this.name = randCatchPhrase();
   }
}
